export class intakeFormDataKeys {
  constructor() {
    return {
      code: null,
      patientCaseId: null,
      person: null,
      personOther: null,
      currentDate: null,
      birthDate: null,
      birthplace: null,
      housemates: null,
      housematesInfo: [],
      education: null,
      ocupation: null,
      workingFromHome: null,
      whereMask: [],
      whyVaccineYes: [],
      vaccineYesOther: null,
      whyVaccineNo: [],
      vaccineNoOther: null,
      takeVaccine: null,
      takenCovidVaccine: null,
      vaccineDates: [],
      attendEvent10: null,
      attendEvent10Frequency: null,
      hasTraveled: null,
      travelCountries: [],
      height: null,
      weight: null,
      disorders: [],
      disorderOther: null,
      hadCovidSymptoms: null,
      covidSymptoms: [],
      covidSymptomsOther: null,
      symptomsBegin: null,
      symptomsBeginDates: [],
      symptomsEndDates: [],
      symptomsEnd: null,
      contactedDoctor: null,
      admittedHospital: null,
      hadTest: null,
      whyNoTest: null,
      covidTestResult: [],
      testDate: null,
      testMethod: null,
      contactPositivePerson: null,
      quarantaine: null,
      followedAdvise: null,
      whereContacted: [],
      whereContactedOther: null,
      ashamedOfCovid: null,
      scaredOfCovid: null,
    }
  }
}